import { Col, Row, Table } from 'reactstrap';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentHeading } from '../../Shared/Content/ContentHeading';
import { ContentBody } from '../../Shared/Content/ContentBody';

export const SecurityAndProtection = () => {
    return (
        <div id="security-and-protection">
            <ContentBlock className="evSupplyEquipmentSection">
                <ContentHeading title="Electric Vehicle Supply Equipment Security and Protection"/>
                <ContentBody>
                    <div className="heading5">
                        Making sure your investment in EVs and EVSE are protected from those who wish to harm or tamper with them can be just as important as maintenance. Below you'll find some best practices to help avoid the most common kinds of security and protection breaches, in order of least to most effort.
                    </div>
                    <Row className="contentBlock tableBlock">
                        <Col>
                            <div className="subContent">
                                <h4 className="css_heading bold">Theft Protection</h4>
                                <div className="body indent">
                                    <p>
                                        <ol>
                                            <li>Purchase EVSE with an integrated theft deterrence device.<sup className={'super-footnote'}>3</sup> Theft deterrence devices include locking charging cord storage compartment, locking internal component storage compartment, security camera, locking cord, locking charger holster, and tamper-proof installation fasteners.</li>
                                            <li>Place charging stations in well-lit, visible areas to reduce risk.</li>
                                            <li>Place charging stations behind a restricted-access gate, such as a garage door or property fence.</li>
                                            <li>Install dashboard cameras in EVs to monitor surroundings while parked.</li>
                                            <li>Assign a parking attendant.<sup className={'super-footnote'}>4</sup></li>
                                            <li>Purchase an EV with wireless charging capability to eliminate the need for charging cords.</li>
                                        </ol>
                                    </p>
                                </div>

                                <h4 className="css_heading bold">Unauthorized Use Protection</h4>
                                <div className="body indent">
                                    <p>
                                        <ol>
                                            <li>Most vehicles lock the charger in the charging port when the vehicle is locked, so make sure to lock your vehicle during charging sessions.</li>
                                            <li>Charge in well-lit, visible areas to reduce risk.</li>
                                            <li>Monitor surroundings using a dashboard camera or an integrated EVSE security camera.</li>
                                        </ol>
                                    </p>
                                </div>

                                <h4 className="css_heading bold">Cyberattacks and Network Protection</h4>
                                <div className="body indent">
                                    <p>
                                        <ol>
                                            <li>To ensure that the EVSE complies with the organization's cyber security policies, install EVSE that implements the most recent version of existing standards, such as ISO 15118.<sup className={'super-footnote'}>5</sup> ISO 15118 is an international standard vehicle-to-grid (V2G) communication interface. Plug & Charge is an ISO 15118 feature that uses asymmetric cryptography to automatically establish a secure connection to receive energy and data from compatible charging stations.</li>
                                            <li>Reach out to an automotive cybersecurity company, such as Upstream, that can help provide additional cloud-based security against cyberattacks targeting charging infrastructure.</li>
                                        </ol>
                                    </p>
                                </div>

                                <div className="disclaimer">
                                    <p><sup className={'super-footnote'}>3</sup>Site Resilience and Energy Assessment Process for Key Assets</p>
                                    <p><sup className={'super-footnote'}>4</sup>Alternative Fuels Data Center: Workplace Charging for Electric Vehicles (<a href={"https://energy.gov"} target={"_blank"} rel={"noreferrer"}>energy.gov</a>)</p>
                                    <p><sup className={'super-footnote'}>5</sup>Government Fleet and Public Sector Electric Vehicle Supply Equipment (EVSE) Cybersecurity Best Practices and Procurement Language Report (<a href={"https://www.bts.gov"} target={"_blank"} rel={"noreferrer"}>www.bts.gov</a>)</p>
                                </div>
                            </div>
                        </Col>
                    </Row>

                </ContentBody>
            </ContentBlock>
        </div>
    );

};
